import { connect } from 'react-redux';
import { Card, CardFooter, CardHeader, CardTitle, Modal } from "reactstrap";

import Circle from 'components/markup/loading/Circle'

import ApiError from 'components/markup/layout/ApiError'

const Modalify = ({showModal, toggleModal, title, sections, footer, header, size, err}) => {
    const loading = !sections.length

    if(toggleModal) return (
        <Modal
            className="modal-dialog-centered"
            isOpen={showModal}
            toggle={toggleModal}
            size={size ? size : 'lg'}
        >

            <div className="modal-header">
                <h5 className="modal-title">{title}</h5>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={toggleModal}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>

            {loading ? (
                <div className="pb-4 pt-5 mb-2">
                    <Circle />
                </div>
            ) : (
                <div>
                    {header ? <div className="modal-body border-bottom">{header}</div> : ''}
                    {sections.map((section, i) => (
                        <div key={i} className={`modal-body ${i === 0 ? '' : 'border-top'}`}>
                            {section}
                        </div>
                    ))}
                </div>
            )}

            {err ? (
                <ApiError err={err} />
            ) : null}

            <div className="modal-footer text-right">
                {footer}
            </div>

        </Modal>
    )

    return (
        <Card>
            {title ? (
                <CardHeader>
                    <CardTitle className="mb-0">{title}</CardTitle>
                </CardHeader>
            ) : null}
            {loading ? (
                <div className="pb-4 pt-5 mb-2">
                    <Circle />
                </div>
            ) : sections.map((section, i) => (
                <CardFooter key={i} style={i === 0 ? {borderTop: 'none'} : {}}>
                    {section}
                </CardFooter>
            ))}


            {err ? (
                <ApiError err={err} />
            ) : null}

            <CardFooter className="text-right">
                {footer}
            </CardFooter>

        </Card>
    );

}


const mapStateToProps = state => {
	return {
	    company: state.company.company,
	};
};

export default connect(mapStateToProps, '')(Modalify);